export default __webpack_public_path__ + "static/media/pieChart.c7931a14.png";